/**
 * V64.4: 상위 조직장 후보 목록 조회 훅
 *
 * listOrgLeaderCandidates CF를 호출하여
 * 근무평가 상위 조직장 선택 모달의 후보 리스트를 가져옵니다.
 *
 * getEmployees와 달리 HR/Admin 권한 불필요 — 조직관리 접근 가능한 역할이면 호출 가능.
 * 반환 필드: id, nameKo, orgUnitName, jobTitle, assignedRoleIds (개인정보 최소 노출)
 */

import { useState, useEffect } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../firebase/config';

export interface OrgLeaderCandidate {
  id: string;
  nameKo: string;
  orgUnitName: string;
  jobTitle: string;
  assignedRoleIds: string[];
}

interface UseOrgLeaderCandidatesResult {
  candidates: OrgLeaderCandidate[];
  isLoading: boolean;
  error: string | null;
}

export function useOrgLeaderCandidates(enabled: boolean): UseOrgLeaderCandidatesResult {
  const [candidates, setCandidates] = useState<OrgLeaderCandidate[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled || !functions) return;

    let cancelled = false;
    setIsLoading(true);
    setError(null);

    const fn = httpsCallable(functions, 'listOrgLeaderCandidates');
    fn({})
      .then((result: any) => {
        if (cancelled) return;
        const data = result.data as { success: boolean; candidates: OrgLeaderCandidate[] };
        if (data.success) {
          setCandidates(data.candidates);
        }
      })
      .catch((err: any) => {
        if (cancelled) return;
        console.error('[V64.4] listOrgLeaderCandidates 호출 실패:', err);
        setError(err.message || '상위 조직장 후보 조회 실패');
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => { cancelled = true; };
  }, [enabled]);

  return { candidates, isLoading, error };
}
